@if (mediaQueryService.breakpoints$ | async; as breakpoints) {
  <custom-upload
    [imagePicker]="selfInstance"
    [parentForm]="formElement"
    [uploadedImage]="uploadedImage"
  ></custom-upload>

  <div class="gallery-container flex">
    <button
      [disableRipple]="true"
      [ngClass]="{ mobile: breakpoints.ltMd }"
      [ngStyle]="{ visibility: currentSlide == 0 ? 'hidden' : 'visible' }"
      (click)="prevSlide()"
      aria-label="Previous"
      class="slider-nav-btn prev"
      data-test-id="imagePicker-prevSlide-button"
      mat-mini-fab
      type="button"
    >
      <mat-icon class="rotate-90" svgIcon="arrow_down"></mat-icon>
    </button>
    <div [ngClass]="{ disabled: disableSlider }" #pickerSlider class="image-picker-slider-container">
      <div #presetList class="gallery-container element-list clearfix flex flex-col flex-start-start gap-6">
        @for (preset of banners; track preset; let i = $index) {
          <div class="gallery-row flex flex-start-stretch gap-6">
            @for (item of preset; track item; let j = $index) {
              <div
                [ngClass]="{ 'item-active': getEventBannerActive(item) }"
                [ngStyle]="item.PresetUrl ? { 'background-image': 'url(' + item.PresetUrl + ')' } : {}"
                [style.width.px]="itemWidth"
                (click)="selectImage(item)"
                (mouseleave)="onEventBannerLeave()"
                (mouseover)="onEventBannerOver(item)"
                #presetEl
                class="gallery-item flex flex-start-stretch"
                role="button"
              ></div>
            }
          </div>
        }
      </div>
    </div>
    <button
      [ngClass]="{ mobile: breakpoints.ltMd }"
      [ngStyle]="{
        visibility: currentSlide === slidesNumber - 1 ? 'hidden' : 'visible',
      }"
      (click)="nextSlide()"
      aria-label="Next"
      class="slider-nav-btn next"
      data-test-id="imagePicker-nextSlide-button"
      mat-mini-fab
      type="button"
    >
      <mat-icon class="rotate-270" svgIcon="arrow_down"></mat-icon>
    </button>
  </div>
  @if (!selectedImage && uploadGroup.get('fileName').touched) {
    <validation-messages
      [field]="uploadGroup.get('fileName')"
      [texts]="{ required: 'Please, select or add an image' }"
      messages="['required']"
    ></validation-messages>
  }
}
